module.exports = __webpack_public_path__ + "static/k-cake-menu-3676611f69ffe76c66baa9563005d337.jpg";